import React from 'react';
import Style from './CompleteShopping.module.css';
import { separate } from '../../Seprate/Seprate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const CompleteShopping = ({ finalize, totalPrice, totalCount }) => {
  return (
    <div className={Style.TotalPrice}>
      <div className={Style.innerContainer}>
        {totalPrice > 0 ? (
          <div className={Style.priceWrapper}>
            <span className={Style.priceLabel}>
              مجموع کل {totalCount ? `(${totalCount} کالا)` : ''}:
            </span>
            <div className={Style.priceValue}>
              <strong>{separate(totalPrice)}</strong>
              <small>تومان</small>
            </div>
          </div>
        ) : <div />}

        <button
          type="button"
          className={Style.finalizeBtn}
          onClick={finalize}
        >
          <span>نهایی کردن خرید</span>
          <FontAwesomeIcon icon={faArrowLeft} className={Style.btnArrow} />
        </button>
      </div>
    </div>
  );
};

export default CompleteShopping;
 